<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="onAdd()"
                    matTooltip="{{ 'new_record_hint' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>

            <div class="main-toolbar-spacer"></div>

            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">

                    <div class="filter-item">
                        <ng-container *transloco="let t">
                            <pixl-free-filter-input
                                [label]="t('title')"
                                [matIcon]="'search'"
                                [hint]="getSearchFilterHint()"
                                [minLength]="freeFilterLen"
                                (onKeyUpChange)="setFreeFilter($event)"
                            />
                        </ng-container>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Anwendungen</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setConsumerFilter($event)"
                            >
                                @for (consumer of consumers$ | async; track consumer) {
                                <mat-option [value]="consumer.id">{{ consumer.name }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <pixl-multi-combo-entity-search
                            [label]="moduleLabels"
                            [observable$]="modules$"
                            [namingColumn]="'title'"
                            [externalSearch]="true"
                            (onStateChange)="receiveModuleData($event)"
                            (onSearchChange)="receiveModuleQuery($event)"
                            (scrolledToEnd)="loadMoreModules($event)"
                            [(selectedValues)]="selectedModules"
                        >
                        </pixl-multi-combo-entity-search>
                    </div>

                    <div class="filter-item">
                        <pixl-multi-combo-entity-search
                            [label]="learningSectionLabels"
                            [observable$]="learningSections$"
                            [namingColumn]="'name'"
                            [externalSearch]="true"
                            (onStateChange)="receiveLearningSectionData($event)"
                            (onSearchChange)="receiveLearningSectionQuery($event)"
                            (scrolledToEnd)="loadMoreLearningSections($event)"
                            [(selectedValues)]="selectedLearningSections"
                        >
                        </pixl-multi-combo-entity-search>
                    </div>

                    <div class="filter-item">
                        <pixl-state-cb
                            (onStateChange)="setStatusFilter($event)"
                            [withEmptyOption]="true"
                        />
                    </div>
                </div>

            </div>
            <div class="main-toolbar-spacer-right"></div>
        </div>
        <div class="table-header-overlay"></div>
    </div>

    <div class="table-container mat-elevation-z4">
        @if (learningUnits$ | async; as learningUnits) {
        <table
            mat-table
            [dataSource]="learningUnits"
            matSort
            [trackBy]="trackById"
        >
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="onEdit(learningUnit)"
                        matTooltip="{{ 'edit_record_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>

                    <button
                        [class.btn-info]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Copy"
                        (click)="onCopy(learningUnit)"
                        matTooltip="{{ 'copy_record_hint' | transloco }}"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>

                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        color="warn"
                        aria-label="Delete"
                        (click)="onDelete(learningUnit)"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >ID</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                >{{ learningUnit.id }}</td>
            </ng-container>

            <ng-container matColumnDef="title">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "title" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                >{{ learningUnit.title }}</td>
            </ng-container>

            <ng-container matColumnDef="subtitle">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "sub_title" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                >{{ learningUnit.subtitle }}</td>
            </ng-container>

            <ng-container matColumnDef="consumer">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "consumer" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                >
                    @if (learningUnit.consumer?.id; as consumerId) {
                    <span class="badge badge-dark me-1">
                        {{ getConsumerName(consumerId) }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="modules">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "Module" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                >
                    @for (moduleTitle of getModuleNames(learningUnit.modules); track $index) {
                    <span class="badge badge-dark me-1">
                        {{ moduleTitle }}
                    </span>
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="learningSections">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "lerning_sections" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                >
                    @for (learningSectionName of getLearningSectionNames(learningUnit.learningSections); track $index) {
                    <span class="badge badge-dark me-1">
                        {{ learningSectionName }}
                    </span>
                    }
                </td>
            </ng-container>


            <ng-container matColumnDef="created_at">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "created" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                    class="no-wrap"
                >
                    {{ getCreatedDate(learningUnit.id) | date }}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "state" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let learningUnit"
                >
                    <div
                        class="editstatus"
                        #editStatusDiv
                    >
                        <button
                            class="badge"
                            [ngClass]="getStatusColor(learningUnit.status)"
                        >
                            {{ getStatusText(learningUnit.status) }}
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>
        } @else {
        <pixl-table-loading-spinner [name]="'Lerneinheiten'" />
        }

        <mat-paginator
            [length]="totalItems || 0"
            [pageSize]="pageSize"
            [pageSizeOptions]="[25, 50, 100]"
        ></mat-paginator>
    </div>
</div>